import { Link } from "react-router-dom";
import type { CellProps } from "react-table";

import type { IData } from "../../../types";
import { CacheMenuIcon } from "../../icons";

interface CacheColumnProps {
  id: string;
  headers: Record<string, string>;
  applicationId: string;
}

export const CacheColumn: React.FC<CacheColumnProps> = ({
  id,
  headers,
  applicationId,
}) => {
  const fromCache = !!id;
  const cacheControl = headers["cache-control"];
  return (
    <div className="d-flex w-auto align-content-md-start ">
      {fromCache ? (
        <Link
          to={`/safety-compliance/cache/${applicationId}/${id}`}
          className={`resp-badge ${fromCache ? "resp-from-cache" : ""}`}
        >
          <CacheMenuIcon size={12} /> Cache item
        </Link>
      ) : (
        (cacheControl === "no-cache" || cacheControl === "no-store") && (
          <div>Disabled</div>
        )
      )}
    </div>
  );
};
